import React from 'react';
import PropTypes from 'prop-types';

import { PlayerRow, VerifiedUtrIcons, InsightBlock } from '../GameCardTooltip';
import { lockHandlerPropType } from '../performanceStatsUtils';
import styles from '../performanceStats.scss';

function ResultCard({ card, locked, onLockClick, 'data-testid': dataTestId }) {
    const { match } = card;
    return (
        <div className={styles.resultCard} data-testid={dataTestId}>
            <div className={styles.resultCardTopRow}>
                <span className={styles.resultCardDateGroup}>
                    <span className={styles.resultCardDate} data-testid={dataTestId && `${dataTestId}.date`}>{card.shortDateLabel}</span>
                    <VerifiedUtrIcons classes={styles} data-testid={dataTestId} />
                </span>
            </div>
            {match && (
                <React.Fragment>
                    <PlayerRow player={match.me} sets={match.sets} isWinner={match.profileIsWinner} data-testid={dataTestId && `${dataTestId}.player`} />
                    <PlayerRow player={match.opponent} sets={match.sets} isOpponent isWinner={!match.profileIsWinner} data-testid={dataTestId && `${dataTestId}.opponent`} />
                </React.Fragment>
            )}
            <InsightBlock
                card={card}
                locked={locked}
                onLockClick={onLockClick}
                classes={styles}
                data-testid={dataTestId}
            />
        </div>
    );
}

ResultCard.propTypes = {
    card: PropTypes.shape({
        shortDateLabel: PropTypes.string,
        insight: PropTypes.shape({
            percentLabel: PropTypes.string,
            direction: PropTypes.string,
        }),
        impactWeight: PropTypes.string,
        match: PropTypes.shape({}),
    }).isRequired,
    locked: PropTypes.bool,
    onLockClick: lockHandlerPropType,
    'data-testid': PropTypes.string,
};

ResultCard.defaultProps = {
    locked: false,
    onLockClick: null,
    'data-testid': null,
};

function LastResults({ cards, onViewAll, isLocked, onLockClick, 'data-testid': dataTestId }) {
    if (!cards.length) { return null; }
    return (
        <section className={styles.lastResults} data-testid={dataTestId}>
            <div className={styles.lastResultsHeader}>
                <h4 className={styles.lastResultsTitle} data-testid={dataTestId && `${dataTestId}.title`}>Recent Results</h4>
                {onViewAll && (
                    <button
                        type="button"
                        className={styles.viewAllBtn}
                        onClick={onViewAll}
                        data-testid={dataTestId && `${dataTestId}.view-all-btn`}
                    >
                        View All
                    </button>
                )}
            </div>
            <div className={styles.resultCardGrid}>
                {cards.map((card, cardIndex) => (
                    <ResultCard
                        key={card.id ?? cardIndex}
                        card={card}
                        locked={isLocked && cardIndex > 0}
                        onLockClick={onLockClick}
                        data-testid={dataTestId && `${dataTestId}.card-${card.id ?? cardIndex}`}
                    />
                ))}
            </div>
        </section>
    );
}

LastResults.propTypes = {
    cards: PropTypes.arrayOf(PropTypes.shape({})),
    onViewAll: PropTypes.func,
    isLocked: PropTypes.bool,
    onLockClick: PropTypes.func,
    'data-testid': PropTypes.string,
};

LastResults.defaultProps = {
    cards: [],
    onViewAll: null,
    isLocked: false,
    onLockClick: null,
    'data-testid': null,
};

export default LastResults;
